import $ from 'jquery';
import {els, constants, breakpoints} from './variables';

/**
 * Loop through an array/nodelist and call the passed callback function.
 * @param  {Array}   	array    	Array to be looped over.
 * @param  {Function} 	callback 	Callback function.
 * @param  {???}   		scope
 */
export function forEach(array, callback, scope) {
	if(array) {
		for (var i = 0; i < array.length; i++) {
			callback.call(scope, i, array[i]);
		}
	}
}

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 * @param  {Function} 	func      	Function to debounce
 * @param  {Number} 	wait      	Time to wait in milliseconds
 * @param  {Boolean} 	immediate 	If true is passed, trigger the function on the leading edge, instead of the trailing.
 * @return {Function}
 */
export function debounce(func, wait = 100, immediate = true) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


//! Helper Functions
export function hasClass(el, className) {
	if(el.classList) {
		return el.classList.contains(className);
	} else {
		return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
	}
}

export function addClass(el, className) {
	if(el.classList) {
		el.classList.add(className);
	} else if (!hasClass(el, className)) {
		el.className += " " + className;
	}
}

export function removeClass(el, className) {
	if(el.classList) {
		el.classList.remove(className);
	} else if(hasClass(el, className)) {
		var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
		el.className=el.className.replace(reg, ' ');
	}
}

export function decodeHtml(html) {
	var txt = document.createElement("textarea");
	txt.innerHTML = html;
	return txt.value;
}

export function slugify(text) {
	return text.toLowerCase().replace(/[^\w ]+/g,'').replace(/ +/g,'-');
}

export function addHashToURL(hash) {
	if (history.pushState) {
		var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + hash;
		window.history.pushState({path:newurl},'',newurl);
	}
}

export function scrollToEl(el, offset = 0, delay = 0, duration = 300, callback = false) {
	setTimeout(function() {
		const headerOffset = els.header.outerHeight() + (constants.scrollTopOffset - 2);
		offset = offset ? headerOffset + offset : headerOffset;

		$('html, body').animate({
			scrollTop: el.offset().top - offset
		}, duration).promise().then(callback);
	}, delay);
}

export function isElementInViewport(el) {
	var rect = el.getBoundingClientRect();
    var isVisible = (rect.top >= 0) && (rect.bottom <= window.innerHeight);

    return isVisible;
}
